/**
 * Backend answers `409 { code: 'PUBLISH_IN_PROGRESS' }` when another writer holds the
 * invitation row lock for >3 s. Nothing was charged or written, so retrying is safe.
 */
export const PUBLISH_IN_PROGRESS_MESSAGE = 'Your invitation is being updated — please try again.';

export function isPublishInProgress(err: unknown): boolean {
  const e = err as { status?: number; data?: { code?: string } } | null;
  return e?.status === 409 && e.data?.code === 'PUBLISH_IN_PROGRESS';
}

/** Runs `fn`; on PUBLISH_IN_PROGRESS waits `delayMs` and tries exactly once more. */
export async function withPublishRetry<T>(fn: () => Promise<T>, delayMs = 1000): Promise<T> {
  try {
    return await fn();
  } catch (err) {
    if (!isPublishInProgress(err)) throw err;
    await new Promise((r) => setTimeout(r, delayMs));
    return fn();
  }
}
